import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import AccommodationLinks from '@/scopes/common/components/AccommodationLinks'
import { HeadingLabel } from '../HeadingLabel'

export function LinkedAccommodations() {
  const intl = useIntl()
  const data = useCMSPageField('LinkedAccommodations')

  if (!data?.accommodations?.length) {
    return null
  }

  return (
    <>
      <HeadingLabel text={intl.formatMessage({ id: 'linked_accommodations_title' }, { destinationName: data?.destinationName || '' })} />
      <AccommodationLinks accommodations={data.accommodations} />
    </>
  )
}
